<template>
  <div class="body">
  </div>
</template>

<script>
/* eslint-disable no-console */
import lodash from 'lodash'
import elementResizeEvent from 'element-resize-event'

export default {
  props: ['frame-data', 'left-mouse-mode', 'draw-label-text', 'draw-predicted-text'],
  data: function () {
    return {
      imageLayerId: undefined,
      loaded: false,
      state: {
        coord: {
          x: 0,
          y: 0
        },
        zoom: undefined,
        voi: {
          windowCenter: 127,
          windowWidth: 256
        }
      },
      internalState: {
        moveTouch: undefined,
        zoomTouch: undefined
      }
    }
  },
  methods: {
    listen__x__onresize: function () {
      const Vue = this
      if (Vue.frameData._empty == false) {
        const style = getComputedStyle(this.$el)
        const scaleY = parseInt(style.height) / this.frameData.cornerstoneImage.height
        const scaleX = parseInt(style.width) / this.frameData.cornerstoneImage.width
        const zoom0 = (scaleY < scaleX)? scaleY : scaleX;
        Vue.$cornerstone.resize(Vue.$el, false)
        if (Math.abs(this.state.zoom - zoom0) > 1e-5) {
          let layers = this.$cornerstone.getLayers(this.$el)
          for (let i = 0; i < layers.length; i++) {
            let viewport = layers[i].viewport
            viewport.scale = Vue.state.zoom
            viewport.translation.x = Vue.state.coord.x
            viewport.translation.y = Vue.state.coord.y
          }
          this.$cornerstone.updateImage(this.$el)
        }
      }
    },
    listen__view__onmousedown: function (e, type) {
      const Vue = this
      if (Vue.loaded == false)
        return
      function mouseLeftUpHandler (e) {
        if (e.which == 1) {
          Vue.$parent.$el.removeEventListener('mousemove', mouseLeftMoveHandler)
          Vue.$parent.$el.removeEventListener('mouseup', mouseLeftUpHandler)
        }
      }
      function mouseRightUpHandler (e) {
        if (e.which == 3) {
          Vue.$parent.$el.removeEventListener('mousemove', mouseRightMoveHandler)
          Vue.$parent.$el.removeEventListener('mouseup', mouseRightUpHandler)
        }
      }
      function touchUpHandler (e) {
        if (Array.prototype.findIndex.call(e.changedTouches, v => v.identifier == Vue.internalState.moveTouch.identifier) == -1) return
        Vue.internalState.moveTouch = undefined

        Vue.$parent.$el.removeEventListener('touchmove', touchMoveHandler)
        Vue.$parent.$el.removeEventListener('touchend', touchUpHandler)
      }
      function touchUpHandler2 (e) {
        if (Array.prototype.findIndex.call(e.changedTouches, v => v.identifier == Vue.internalState.zoomTouch.identifier) == -1) return
        Vue.internalState.zoomTouch = undefined

        Vue.$parent.$el.removeEventListener('touchmove', touchMoveHandler2)
        Vue.$parent.$el.removeEventListener('touchend', touchUpHandler2)
      }
      function mouseLeftMoveHandler (e) {
        const deltaX = e.pageX - lastX
        const deltaY = e.pageY - lastY
        lastX = e.pageX
        lastY = e.pageY

        const x = Vue.state.coord.x + (deltaX / Vue.state.zoom)
        const y = Vue.state.coord.y + (deltaY / Vue.state.zoom)
        Vue.listen__state__tochange({coord: {x, y}}, false)
      }
      function mouseRightMoveHandler (e) {
        const deltaX = e.pageX - lastX
        const deltaY = e.pageY - lastY
        lastX = e.pageX
        lastY = e.pageY

        const windowWidth = Math.min(256, Math.max(1, Vue.state.voi.windowWidth + (deltaX / Vue.state.zoom)))
        const windowCenter = Math.min(255, Math.max(0, Vue.state.voi.windowCenter + (deltaY / Vue.state.zoom)))
        Vue.listen__state__tochange({voi: {windowWidth, windowCenter}}, false)
      }
      function touchMoveHandler (e) {
        const idx = Array.prototype.findIndex.call(e.changedTouches, v => v.identifier == Vue.internalState.moveTouch.identifier)
        if (idx == -1) return
        const touch = e.changedTouches[idx]

        const deltaX = touch.pageX - lastX
        const deltaY = touch.pageY - lastY
        lastX = touch.pageX
        lastY = touch.pageY

        if (Vue.internalState.zoomTouch == undefined) {
          const x = Vue.state.coord.x + (deltaX / Vue.state.zoom)
          const y = Vue.state.coord.y + (deltaY / Vue.state.zoom)
          // Vue.state.coord = {x, y}
          Vue.listen__state__tochange({coord: {x, y}}, false)
        }
      }
      function touchMoveHandler2 (e) {
        const idx = Array.prototype.findIndex.call(e.changedTouches, v => v.identifier == Vue.internalState.zoomTouch.identifier)
        if (Vue.internalState.moveTouch == undefined || idx == -1) return
        const touch = e.changedTouches[idx]

        const cdist = 2.5 * (Math.abs(touch.pageX - Vue.internalState.moveTouch.pageX) + Math.abs(touch.pageY - Vue.internalState.moveTouch.pageY)) / (window.innerHeight + window.innerWidth)
        if (dist == undefined) {
          dist = cdist
          return
        }
        const as = cdist - dist
        dist = cdist
        const scale = Vue.state.zoom + as
        if (scale > 0) {
          // Vue.state.zoom = scale
          Vue.listen__state__tochange({zoom: scale}, false)
        }
      }
      function mouseLeftDownHandler () {
        Vue.$parent.$el.addEventListener('mousemove', mouseLeftMoveHandler)
        Vue.$parent.$el.addEventListener('mouseup', mouseLeftUpHandler)
      }
      function mouseRightDownHandler () {
        Vue.$parent.$el.addEventListener('mousemove', mouseRightMoveHandler)
        Vue.$parent.$el.addEventListener('mouseup', mouseRightUpHandler)
      }
      function touchDownHandler () {
        Vue.$parent.$el.addEventListener('touchmove', touchMoveHandler)
        Vue.$parent.$el.addEventListener('touchend', touchUpHandler)
      }
      function touchDown2Handler () {
        Vue.$parent.$el.addEventListener('touchmove', touchMoveHandler2)
        Vue.$parent.$el.addEventListener('touchend', touchUpHandler2)
      }

      if (Vue.state.coord == undefined) return

      e.preventDefault()
      let lastX, lastY, dist
      if (type == 'touch' && e.which == 0) {
        if (Vue.internalState.moveTouch != undefined) {
          Vue.internalState.zoomTouch = Vue.copyTouch(e.changedTouches[0])
          touchDown2Handler()
        } else {
          Vue.internalState.moveTouch = Vue.copyTouch(e.changedTouches[0])
          lastX = e.changedTouches[0].pageX
          lastY = e.changedTouches[0].pageY
          touchDownHandler()
        }
      } else if (type == 'mouse' && e.which == 1) {
        lastX = e.pageX
        lastY = e.pageY
        mouseLeftDownHandler()
      }
      else if (type == 'mouse' && e.which == 3) {
        lastX = e.pageX
        lastY = e.pageY
        mouseRightDownHandler()
      }
    },
    listen__view__onwheel: function (e) {      
      const Vue = this
      if (Vue.loaded == false)
        return
      if (Vue.state.zoom == undefined) return
      const as = e.wheelDelta < 0 || e.detail > 0 || e.deltaY >= 0 ? -0.10 : 0.10
      let scale = Vue.state.zoom + as
      scale = Math.max(0.2, Math.min(3, scale))
      if (scale > 0) {
        // Vue.state.zoom = scale
        Vue.listen__state__tochange({zoom: scale}, false)
      }
      return false
    },
    listen__state__tochange: function (data, use_layer = false) {
      async function change () {
        if (data.coord != undefined) {
          Vue.state.coord = {x: data.coord.x, y: data.coord.y}
        }
        if (data.zoom != undefined) {
          Vue.state.zoom = data.zoom
        }
        if (data.voi != undefined) {
          Vue.state.voi = {windowCenter: data.voi.windowCenter, windowWidth: data.voi.windowWidth}
        }
      }
      const Vue = this
      if (use_layer == true) {
        Vue.layer.message = 'update state...'
        Vue.layer.active = true
        Vue.doubleRaf(change)
      } else
        change()
      Vue.$emit('onstatechange', Vue.state);
    },
    updateFields: function () {
      const Vue = this
      
      if (this.loaded == true && this.frameData._empty == false && this.frameData.fields != undefined) {
        this.$cornerstoneTools.clearToolState(this.$el, 'TemplateOcr');
        for (let field of this.frameData.fields) {
          const measurementData = {
            id: field.id,
            name: field.name,
            predictedText: field.text,
            visible: true,
            active: false,
            color: field.color,
            invalidated: true,
            drawLabelText: Vue.drawLabelText,
            drawPredictedText: Vue.drawPredictedText,
            handles: {
              start: {
                x: field.rect[0],
                y: field.rect[1],
                highlight: true,
                active: false,
                cantSelected: Vue.leftMouseMode != 'edit',
              },
              end: {
                x: field.rect[2],
                y: field.rect[3],
                highlight: true,
                active: true,
                cantSelected: Vue.leftMouseMode != 'edit',
              },
              textBox: {
                active: true,
                hasMoved: false,
                movesIndependently: false,
                drawnIndependently: true,
                allowedOutsideImage: true,
                hasBoundingBox: Vue.drawLabelText || Vue.drawPredictedText,
                cantSelected: Vue.leftMouseMode != 'edit',
              },
            },
          };
          this.$cornerstoneTools.addToolState(this.$el, 'TemplateOcr', measurementData)
        }
        this.$cornerstone.updateImage(this.$el);
      }
    },
    updateFieldsDrawTextBox: function () {
      const Vue = this
      if (this.loaded == true && this.frameData._empty == false) {
        const toolState = this.$cornerstoneTools.getToolState(this.$el, 'TemplateOcr');

        if (toolState == undefined)
            return

        for (let datum of toolState.data) {
          datum.drawLabelText = Vue.drawLabelText
          datum.drawPredictedText = Vue.drawPredictedText
          if (datum.handles.textBox != undefined) {
            datum.handles.textBox.hasBoundingBox = Vue.drawLabelText || Vue.drawPredictedText
          }
        }
        this.$cornerstone.updateImage(this.$el);
      }
    },
    fitToWindow: function () {
      if (this.loaded == true && this.frameData._empty == false) {
        const style = getComputedStyle(this.$el)
        const scaleY = parseInt(style.height) / this.frameData.cornerstoneImage.height
        const scaleX = parseInt(style.width) / this.frameData.cornerstoneImage.width
        
        this.state.coord = {x: 0, y: 0};
        this.state.zoom = (scaleY < scaleX)? scaleY : scaleX;
        this.$emit('onstatechange', this.state);
      }
    },
    zoom: function (value) {
      this.listen__state__tochange({zoom: value}, false)
    },
    move: function (rect) {
      if (this.loaded == true) {
        const style = getComputedStyle(this.$el)
        const elWidth = parseInt(style.width)
        const elHeight = parseInt(style.height)
        const x = elWidth / 2 / this.state.zoom - ((elWidth - this.frameData.cornerstoneImage.width * this.state.zoom) / 2 / this.state.zoom + (rect[0] + rect[2]) / 2)
        const y = elHeight / 2 / this.state.zoom - ((elHeight - this.frameData.cornerstoneImage.height * this.state.zoom) / 2 / this.state.zoom + (rect[1] + rect[3]) / 2)
        this.listen__state__tochange({coord: {x: x, y: y}}, false)
      }
    },
    mousedown: function (e, type) {
      if (this.leftMouseMode == 'pan')
        this.listen__view__onmousedown(e, type);
    },
    getTemplateOcrOptions: function () {
      return {
        mouseButtonMask: 1,
        callbackFailToCreation: this.callbackFailToCreation,
        callbackSuccessToCreation: this.callbackSuccessToCreation,
        callbackRemoveByOutside: this.callbackRemoveByOutside,
        callbackDoneMoving: this.callbackDoneMoving
      }
    },
    callbackFailToCreation: function () {
      this.$q.notify({
        message: '판독영역은 이미지 안에 위치해야 합니다.',
        icon: 'announcement',
        color: 'red'
      })
    },
    callbackSuccessToCreation: function (success, fail) {
      this.$emit('onfieldadd', {success, fail})
    },
    callbackRemoveByOutside: function (ctData) {
      this.$emit('onfieldremove', ctData.id)
      this.$q.notify({
        message: `"${ctData.name}"필드가 지워졌습니다.`,
        icon: 'announcement',
        color: 'red'
      })
    },
    callbackDoneMoving: function (ctData) {
      this.$emit('onfieldmove', {
        id: ctData.id,
        rect: [
          parseInt(ctData.handles.start.x),
          parseInt(ctData.handles.start.y),
          parseInt(ctData.handles.end.x),
          parseInt(ctData.handles.end.y)
        ]
      })
    },
    removeCtAnnotation: function (fieldId) {
      const ctData = this.$cornerstoneTools.getToolState(this.$el, 'TemplateOcr');

      if (ctData == undefined)
        return

      const idx = ctData.data.map(v => v.id).indexOf(fieldId)
      if (idx != -1) {
        this.$cornerstoneTools.removeToolState(this.$el, 'TemplateOcr', ctData.data[idx]);
        this.$cornerstone.updateImage(this.$el)
      }
    },
    setVisibleAnnotation: function (ids) {
      const ctData = this.$cornerstoneTools.getToolState(this.$el, 'TemplateOcr');

      if (ctData == undefined)
        return

      for (let data of ctData.data) {
        if (ids.indexOf(data.id) != -1)
          data.visible = true
        else
          data.visible = false
      }
      this.$cornerstone.updateImage(this.$el)
    }
  },
  computed: {
  },
  watch: {
    "state.coord": function (coord) {
      if (this.loaded == true && this.frameData._empty == false && coord != undefined) {
        let layers = this.$cornerstone.getLayers(this.$el)
        for (let i = 0; i < layers.length; i++) {
          let viewport = layers[i].viewport
          viewport.translation.x = coord.x
          viewport.translation.y = coord.y
        }
        this.$cornerstone.updateImage(this.$el)
      }
    },
    'state.zoom': function (zoom) {
      if (this.loaded == true && this.frameData._empty == false && zoom != undefined) {
        let layers = this.$cornerstone.getLayers(this.$el)
        for (let i = 0; i < layers.length; i++) {
          let viewport = layers[i].viewport
          viewport.scale = zoom
        }
        this.$cornerstone.updateImage(this.$el)
      }
    },
    'state.voi': function (voi) {
      if (this.loaded == true && this.frameData._empty == false) {
        let layer = this.$cornerstone.getLayer(this.$el, this.imageLayerId)
        layer.viewport.voi.windowWidth = voi.windowWidth
        layer.viewport.voi.windowCenter = voi.windowCenter
        this.$cornerstone.updateImage(this.$el)
      }
    },
    'frameData._empty': function (isEmpty) {
      if (isEmpty == false) {
        this.$cornerstone.enable(this.$el);
        elementResizeEvent(this.$el, lodash.debounce(this.listen__x__onresize, 10))
        const image = this.frameData.cornerstoneImage
        let defViewport = this.$cornerstone.getDefaultViewport(this.$el, image)
        const style = getComputedStyle(this.$el)
        const scaleY = parseInt(style.height) / image.height
        const scaleX = parseInt(style.width) / image.width

        this.state = {
          coord: {
            x: 0,
            y: 0
          },
          zoom: (scaleY < scaleX)? scaleY : scaleX,
          voi: {
            windowCenter: 127,
            windowWidth: 256
          }
        }

        defViewport.scale = this.state.zoom
        defViewport.translation.y = this.state.coord.y
        defViewport.translation.x = this.state.coord.x
        defViewport.voi.windowCenter = this.state.voi.windowCenter
        defViewport.voi.windowWidth = this.state.voi.windowWidth
        const imageLayerId = this.$cornerstone.addLayer(this.$el, this.frameData.cornerstoneImage, {viewport: defViewport})
        this.imageLayerId = imageLayerId
        this.loaded = true;
        
        const TemplateOcrTool = this.$cornerstoneTools.TemplateOcrTool;
        this.$cornerstoneTools.addToolForElement(this.$el, TemplateOcrTool);
        
        if (this.leftMouseMode == 'add') {
          this.$cornerstoneTools.setToolActiveForElement(this.$el, 'TemplateOcr', {mode: 'add', ...this.getTemplateOcrOptions()})
        } else if (this.leftMouseMode == 'edit') {
          this.$cornerstoneTools.setToolActiveForElement(this.$el, 'TemplateOcr', {mode: 'edit', ...this.getTemplateOcrOptions()})
        } else {
          this.$cornerstoneTools.setToolEnabledForElement(this.$el, 'TemplateOcr', {mode: 'pan', ...this.getTemplateOcrOptions()})
        }
        this.updateFields()
        this.$emit('onstatechange', this.state);
      } else {
        this.loaded = false;
        elementResizeEvent.unbind(this.$el);
        this.$cornerstone.disable(this.$el);
      }
    },
    leftMouseMode: function () {
      if (this.loaded == true && this.frameData._empty == false) {
        if (this.leftMouseMode == 'add') {
          this.$cornerstoneTools.setToolActiveForElement(this.$el, 'TemplateOcr', {mode: 'add', ...this.getTemplateOcrOptions()})
          const toolState = this.$cornerstoneTools.getToolState(this.$el, 'TemplateOcr');
          
          if (toolState == undefined)
            return

          for (let datum of toolState.data) {
            datum.handles.start.cantSelected = true
            datum.handles.end.cantSelected = true
            datum.handles.textBox.cantSelected = true
          }
        } else if (this.leftMouseMode == 'edit') {
          this.$cornerstoneTools.setToolActiveForElement(this.$el, 'TemplateOcr', {mode: 'edit', ...this.getTemplateOcrOptions()})
          const toolState = this.$cornerstoneTools.getToolState(this.$el, 'TemplateOcr');

          if (toolState == undefined)
            return

          for (let datum of toolState.data) {
            datum.handles.start.cantSelected = false
            datum.handles.end.cantSelected = false
            datum.handles.textBox.cantSelected = false
          }
        } else
          this.$cornerstoneTools.setToolEnabledForElement(this.$el, 'TemplateOcr', {mode: 'pan', ...this.getTemplateOcrOptions()})
      }
    },
    'drawLabelText': function () {
      this.updateFieldsDrawTextBox()
    },
    'drawPredictedText': function () {
      this.updateFieldsDrawTextBox()
    }
  },
  mounted() {
  }
}
</script>

<style scoped>
.body {
  position: relative;
  min-width: 0;
  min-height: 0;
  margin: 0;
  padding: 0;
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
    -khtml-user-select: none; /* Konqueror HTML */
      -moz-user-select: none; /* Firefox */
      -ms-user-select: none; /* Internet Explorer/Edge */
          user-select: none; /* Non-prefixed version, currently
                                supported by Chrome and Opera */
}
.body * {
  pointer-events: none;
}
</style>